import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const toKey = (v) => { const b = (v + '='.repeat((4 - (v.length % 4)) % 4)).replace(/-/g, '+').replace(/_/g, '/'); return Uint8Array.from(atob(b), (c) => c.charCodeAt(0)); };

export const pushSupported = () => 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window;
export const isStandalone = () => window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;
export const isIos = () => /iphone|ipad|ipod/i.test(window.navigator.userAgent);

export async function currentSubscription() {
  if (!pushSupported()) return null;
  const reg = await navigator.serviceWorker.getRegistration();
  return reg ? reg.pushManager.getSubscription() : null;
}

// Must be called from a tap (iOS requirement). `save` posts the subscription to the backend.
export async function enablePush(save) {
  if (!pushSupported()) throw new Error(isIos() && !isStandalone() ? "Su iPhone installa prima l'app (Condividi → Aggiungi alla schermata Home) e aprila dall'icona" : 'Questo browser non supporta le notifiche');
  if (Notification.permission === 'denied') throw new Error('Notifiche bloccate: riattivale dalle impostazioni del telefono');
  if ((await Notification.requestPermission()) !== 'granted') throw new Error('Permesso per le notifiche non concesso');
  const reg = (await navigator.serviceWorker.getRegistration()) || (await navigator.serviceWorker.register('/sw.js'));
  await navigator.serviceWorker.ready;
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    const { data } = await axios.get(`${API}/push/key`);
    sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: toKey(data.public_key) });
  }
  await save(sub.toJSON());
  return sub;
}
